import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import '@/App.css';
import AuthCallback from '@/pages/AuthCallback';
import About from '@/pages/About';
import WorkHistory from '@/pages/WorkHistory';
import Featured from '@/pages/Featured';
import AdminRedirect from '@/pages/AdminRedirect';
import Landing from '@/pages/Landing';
import Contact from '@/pages/Contact';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export { API, BACKEND_URL };

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment synchronously during render to prevent race conditions
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/work" element={<WorkHistory />} />
      <Route path="/admin" element={<AdminRedirect />} />
      <Route path="/about" element={<About />} />
      <Route path="/featured" element={<Featured />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<Navigate to="/work" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
